export const FEATURE_ROUTES = {
  customer: {
    home: '/',
    /** Legacy portal path — redirects to account. */
    portal: '/customer',
    /** Canonical public storefront (guest browse + add-to-cart). */
    shop: '/shop',
    /** Internal compatibility alias; public canonical name is `shop`. */
    shopper: '/shop',
    /** Canonical indexable individual product page. */
    product: '/product/:identifier/:slug',
    /** Public storefront aliases — canonical URL is `/shop`. */
    catalog: '/catalog',
    products: '/products',
    /** Legacy storefront URL retained only for redirect compatibility. */
    legacyShopper: '/shopper',
    /** Orders, wallet, privacy, bottle returns, security. */
    account: '/account',
    cardSetup: '/customer/card-setup',
    storeComingSoon: '/coming-soon',
    /** Live order tracking page. The customer follows their order's status
     * + driver pin in real time. Wired to socket events `order:status:update`
     * and `driver:location:update`. */
    orderTracking: '/orders/:orderId/track',
    cart: '/cart',
    checkout: '/checkout',
    /** Canonical public customer support & help center URL. */
    support: '/support',
    contact: '/contact'
  },
  auth: {
    forbidden: '/forbidden',
    resetPassword: '/reset-password',
    verifyEmail: '/verify-email',
    signUp: '/signup',
    approveTeenLink: '/teen/approve-link'
  },
  legal: {
    privacy: '/privacy',
    terms: '/terms',
    refunds: '/refunds',
    storePolicy: '/store-policy',
    bottleReturns: '/bottle-returns',
    driverAgreement: '/driver-agreement',
    codeOfConduct: '/code-of-conduct',
    about: '/about',
    howItWorks: '/how-it-works',
    faq: '/faq'
  },
  payments: {
    success: '/success',
    cancel: '/cancel',
    result: '/orders/:orderId'
  },
  driver: {
    home: '/driver',
    payoutSettings: '/driver/payouts',
    onboarding: '/driver/onboarding'
  },
  admin: {
    home: '/admin',
    productQueue: '/admin?module=productCandidates',
    ownerAlias: '/owner',
    managementAlias: '/management'
  },
  tools: {
    scannerEligibility: '/scanner',
    sharedStatus: '/shared/status'
  }
} as const;

